var _path, _path2, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionBuble(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "question_buble") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "cls-1",
    d: "M12,19a10,10,0,0,1-3.62-.68l-4.12,2L5.7,16.71A7.59,7.59,0,0,1,3,11c0-4.41,4-8,9-8s9,3.59,9,8-4,8-9,8M12,1C5.93,1,1,5.49,1,11a9.44,9.44,0,0,0,2.59,6.43L1.12,23.6l6.82-3.31A12.07,12.07,0,0,0,12,21c6.07,0,11-4.49,11-10S18.07,1,12,1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "cls-1",
    d: "M12.4,5a4.54,4.54,0,0,1,2.69.66,2.25,2.25,0,0,1,.91,2,4.73,4.73,0,0,1-.29,1.91,3.43,3.43,0,0,1-1.22,1.23,5.09,5.09,0,0,0-1.18,1,1.23,1.23,0,0,0-.24.74V13H10a5.25,5.25,0,0,1,.29-1.82c.28-.46.6-.61,1.39-1.18a9.32,9.32,0,0,0,1.45-1.19A1.14,1.14,0,0,0,13.41,8c0-.67-.53-1-1.59-1a14.12,14.12,0,0,0-2.3.2l-.39.07L9,5.59A9.84,9.84,0,0,1,12.4,5"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    className: "cls-1",
    points: "10 17 13 17 13 14 10 14 10 17"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionBuble);
export default __webpack_public_path__ + "static/media/question_buble.47a13437cc25b201f86c886bea1fbe19.svg";
export { ForwardRef as ReactComponent };